import React from 'react'
import PropTypes from 'prop-types'
import { Box, Grid } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

import TutorAvatar from 'src/pages/SchedulePage/subcomponents/TutorAvatar/TutorAvatar'

import checkmark from './assets/checkmark.svg'

const OVERFLOW = {
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}
const FilterItem = ({
  id,
  isFavorite,
  avatarUrl,
  name,
  login,
  handleChange,
  checked,
  isFullyBooked,
}) => {
  return (
    <Box
      sx={{ userSelect: 'none', ':hover': { cursor: 'pointer' } }}
      key={id}
      as="label"
      p="1x"
      pr="2x"
      borderRadius="40px"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="gray88"
      mb="1x"
      justifyContent="space-between"
      alignItems="center"
      display="flex"
    >
      <Grid
        gridTemplateColumns="auto 1fr"
        gridGap="1x"
        alignItems="center"
        mr="0,25x"
      >
        <TutorAvatar isFavorite={isFavorite} avatarUrl={avatarUrl} />
        <Box
          as="p"
          sx={OVERFLOW}
          title={name}
          aria-label={isFavorite ? t('favorite tutor: %{name}', { name }) : ''}
        >
          {login}
        </Box>
      </Grid>
      <Box as="p" variant="text.paragraph" color="gray60" sx={OVERFLOW}>
        {isFullyBooked && t('Fully booked!')}
      </Box>
      {!isFullyBooked && (
        <Box
          sx={{
            marginTop: '0 !important',
            height: '20px',
            width: '20px',
            borderRadius: '2px',
            appearance: 'none',
            cursor: 'pointer',
            backgroundColor: 'white',
            borderColor: 'black',
            borderWidth: '1px',
            borderStyle: 'solid',
            ':checked': {
              backgroundColor: 'black',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              backgroundImage: `url(${checkmark})`,
            },
            ':disabled': {
              borderColor: 'transparent',
            },
          }}
          as="input"
          id={id}
          onChange={handleChange}
          type="checkbox"
          checked={checked}
        ></Box>
      )}
    </Box>
  )
}

FilterItem.propTypes = {
  id: PropTypes.string,
  login: PropTypes.string,
  isFavorite: PropTypes.bool,
  avatarUrl: PropTypes.string,
  name: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  isFullyBooked: PropTypes.bool,
}

export default FilterItem
